import { DatePipe } from '@angular/common';
import { Component, OnInit, Type } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DeliveryLocationsJeevesComponent, DeliveryLocationsService } from 'gung-standard-jeeves';
import { SelectedCustomerService, AuthService, GungFlowService, GungFlow } from 'gung-standard';
import { first, mergeMap } from 'rxjs';
import { forkJoin, Observable, of } from 'rxjs';
class PackagingRow {
  amount: number;
  parcelType: string; // kollislag
  weight: number; // kg
  volume: number; // m^3
  length: number; // cm
  width: number; // cm
  height: number; // cm
  articleType: string; // varuslag

  constructor() {
    this.amount = 1;
    this.parcelType = '';
    this.weight = 0;
    this.volume = 0;
    this.length = 0;
    this.width = 0;
    this.height = 0;
    this.articleType = '';
  }
}

class ParcelType {
  id: string;
  name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }
}

class ReturnService {
  id: string;
  name: string;

  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }
}

@Component({
  selector: 'cult-cult-return-info-step',
  templateUrl: './cult-return-info-step.component.html',
  styleUrls: ['./cult-return-info-step.component.scss']
})
export class CultReturnInfoStepComponent extends DeliveryLocationsJeevesComponent implements OnInit {
  packagingRows: PackagingRow[] = [];
  parcelTypes: ParcelType[] = [];
  returnServices: ReturnService[] = [];
  minReturnDate: Date = new Date();

  public formReturn: FormGroup;

  public currentFlow: GungFlow;

  constructor(
    protected selectedCustomerService: SelectedCustomerService,
    protected deliveryLocationsService: DeliveryLocationsService,
    protected formBuilder: FormBuilder,
    protected authService: AuthService,
    protected datePipe: DatePipe,
    protected gungFlowService: GungFlowService
  ) {
    super(selectedCustomerService, deliveryLocationsService, formBuilder, authService);
  }

  ngOnInit() {
    this.checkout.extra.unifaunReturn = this.checkout.extra.unifaunReturn || {};
    addWorkdays(this.minReturnDate, 1);

    this.returnServices.push(new ReturnService('ASP2', 'DHL Pall'));
    this.returnServices.push(new ReturnService('AEX', 'DHL Paket'));

    this.gungFlowService
      .getSelectedFlow()
      .pipe(first())
      .subscribe(currentFlow => {
        this.currentFlow = currentFlow;
      });

    super.ngOnInit();
  }

  addPackagingRow() {
    this.packagingRows.push(new PackagingRow());
  }

  removePackagingRow(index: number) {
    this.packagingRows.splice(index, 1);
  }

  protected handleNextButtonClicked(): void {
    this.assignReturnValues(this.formReturn);
    if (this.formReturn.invalid) {
      this.formReturn.markAllAsTouched();
      return;
    }
    if (this.checkout.extra.unifaunReturn.packagingRows.length === 0) {
      this.formReturn.markAllAsTouched();
      return;
    }
    super.handleNextButtonClicked();
  }

  assignReturnValues(formReturn: FormGroup) {
    const rawFormData = formReturn.getRawValue();
    this.checkout.extra.unifaunReturn = {
      ...this.checkout.extra.unifaunReturn,
      ...rawFormData,
      packagingRows: this.packagingRows
    };
  }

  protected initForm() {
    super.initForm();

    this.packagingRows = this.checkout.extra.unifaunReturn.packagingRows || [];
    if (this.packagingRows.length === 0) {
      this.addPackagingRow();
    }

    this.formReturn = this.formBuilder.group({
      ordreturinstruktioner: this.formBuilder.control(this.checkout.extra.unifaunReturn.ordreturinstruktioner || ''),
      ordreturservice: this.formBuilder.control(this.checkout.extra.unifaunReturn.ordreturservice || '', [
        Validators.required
      ]),
      ordreturdatum: this.formBuilder.control(this.checkout.extra.unifaunReturn.ordreturdatum || '', [
        Validators.required
      ]),
      packagingRows: this.formBuilder.control(this.checkout.extra.unifaunReturn.packagingRows || []),
      phone: this.formBuilder.control(this.checkout.extra.unifaunReturn.phone || '', [Validators.required])
    });

    if (this.currentFlow?.isReturnOrder) {
      forkJoin([this.authService.getCurrentUser().pipe(first()), this.gungFlowService.getSelectedFlow().pipe(first())])
        .pipe(
          mergeMap(([user, flow]) => {
            return forkJoin([of(user), of(flow)]);
          })
        )
        .subscribe(([user, flow]) => {
          this.formOh = this.formBuilder.group({
            kundref2: this.formBuilder.control(this.checkout.extra.oh.kundref2 || user.name, [Validators.required]),
            kundbestnr: this.formBuilder.control(flow.name || '', [Validators.required]),
            editext: this.formBuilder.control(this.checkout.extra.oh.editext || '')
          });
        });
    }
  }

  dateSelected(event) {
    const date = event.date;
    const dString: string = this.datePipe.transform(date, 'yyyy-MM-dd');
    this.checkout.extra.unifaunReturn.ordreturdatum = dString;
    this.formReturn.get('ordreturdatum').patchValue(dString);
  }

  getLabel() {
    return 'RETURN_INFORMATION';
  }

  onOrdreturserviceChange(event) {
    this.parcelTypes = [];
    if (event.target.value === 'AEX') {
      this.parcelTypes.push(new ParcelType('PC', 'Paket'));
    }
    if (event.target.value === 'ASP2') {
      this.parcelTypes.push(new ParcelType('ZP', 'Pall'));
      this.parcelTypes.push(new ParcelType('Z1', 'Halv Pall'));
    }
  }
}

function addWorkdays(date: Date, days: number) {
  let daysRemaining = days;
  while (daysRemaining > 0) {
    date.setDate(date.getDate() + 1);
    if (date.getDay() !== 0 && date.getDay() !== 6) {
      daysRemaining--;
    }
  }
}
